import type { RootStateOrAny } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { getIsAuthenticated } from 'selectors/auth'
import { getPromoCode } from 'selectors/basket'
import Cookies from 'utils/GoustoCookies'
import logger from 'utils/logger'

export const getPromoBannerState = (state: RootStateOrAny) => {
  const basketPromoCode = getPromoCode(state)
  const currentPromo = state.promoCurrent || basketPromoCode || ''
  const isAuthenticated = getIsAuthenticated(state)

  const hasCurrentPromo = currentPromo.length > 0

  const hasError =
    !!state.error.get(actionTypes.PROMO_GET) || !!state.error.get(actionTypes.PROMO_APPLY)

  const hide = isAuthenticated || hasError || hasCurrentPromo

  const canApplyPromo = !hide

  return {
    canApplyPromo,
  }
}
export function hasConsentForAnalytics(): boolean {
  try {
    const consentCookieString = Cookies.get('v1_gousto_cookie_consent')
    const consentCookie = consentCookieString ? JSON.parse(consentCookieString) : {}

    return consentCookie?.categories?.includes('ANALYTICS') || false
  } catch (error) {
    if (error instanceof Error) {
      logger.error(`Error parsing consent cookie: ${error.message}`)
    }

    return false
  }
}
